import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import CustomizationStyle from '../../_common/customizationStyle.mdx';
import Form from '../../_common/form.mdx';
import SubmitButton from '../../_common/submitButton.mdx';
import ProcessingIndicator from '../../_common/processingIndicator.mdx';
import ErrorMessage from '../../_common/errorMessage.mdx';
import SuccessScreen from '../_showUniversalCheckout/successScreen.mdx';
import PaymentMethodsOptions from '../../_common/paymentMethodsOptions.mdx';
import ClientSessionCachingEnabled from '../../_common/clientSessionCachingEnabled.mdx';
import ClientSessionLifecycleCallbacks from '../../_common/clientSessionLifecycleCallbacks.mdx';
import OnBeforePaymentCreate from '../../_common/onBeforePaymentCreate.mdx';
import VaultOptions from '../_showUniversalCheckout/vaultOptions.mdx';
import OnCheckoutComplete from '../../_common/onCheckoutComplete.mdx';
import OnCheckoutFail from '../../_common/onCheckoutFail.mdx';
import ManualPaymentHandling from '../../_common/manualPaymentHandling.mdx';
import OnPaymentMethodAction from '../../_common/onPaymentMethodAction.mdx';
import ApiVersion from '../../_common/apiVersion.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`When calling `}<inlineCode parentName="p">{`showUniversalCheckout`}</inlineCode>{` you can provide Drop-In Checkout with some configuration options. These
options range from callbacks notifying you of the current payment's status, to styling options for certain UI
elements.`}</p>
    <Group mdxType="Group">
	<Item title='container' subtitle='string | Element' label='Required' mdxType="Item">
		The container element in which the checkout should be rendered.
	</Item>
	<Item title='locale' subtitle='string' mdxType="Item">
		This option forces the locale. By default, the locale will be set to the browser's locale.
	</Item>
	<ApiVersion mdxType="ApiVersion" />
    </Group>
    <Group open summary='Payment lifecycle callbacks' mdxType="Group">
	<Item title='onPaymentCreationStart' subtitle='() => void' mdxType="Item">
		Notifies you before the checkout tokenizes a payment method and creates a payment.
	</Item>
	<Item title='onBeforePaymentCreate' subtitle='(data: object, handler: object) => void' mdxType="Item">
		<OnBeforePaymentCreate mdxType="OnBeforePaymentCreate" />
	</Item>
	<Item title='onCheckoutComplete' subtitle='(data: object) => void' mdxType="Item">
		<OnCheckoutComplete mdxType="OnCheckoutComplete" />
	</Item>
	<Item title='onCheckoutFail' subtitle='(error: PrimerClientError, data: object, handler: object) => void' mdxType="Item">
		<OnCheckoutFail mdxType="OnCheckoutFail" />
	</Item>
    </Group>
    <ClientSessionLifecycleCallbacks mdxType="ClientSessionLifecycleCallbacks" />
    <Group summary='Event callbacks' mdxType="Group">
	<Item title='onPaymentMethodAction' subtitle='(action: string, data: object) => void' mdxType="Item">
		<OnPaymentMethodAction mdxType="OnPaymentMethodAction" />
	</Item>
    </Group>
    <Group summary='Payment methods options' mdxType="Group">
	<PaymentMethodsOptions mdxType="PaymentMethodsOptions" />
    </Group>
    <Group summary='Vault options' mdxType="Group">
	<VaultOptions mdxType="VaultOptions" />
    </Group>
    <Group summary='Customization options' mdxType="Group">
	<Item title='style' subtitle='CheckoutStyle' mdxType="Item">
		<CustomizationStyle mdxType="CustomizationStyle" />
	</Item>
	<Item title='form' subtitle='object' mdxType="Item">
		<Form mdxType="Form" />
	</Item>
	<Item title='submitButton' subtitle='object' mdxType="Item">
		<SubmitButton mdxType="SubmitButton" />
	</Item>
	<Item title='processingIndicator' subtitle='object' mdxType="Item">
		<ProcessingIndicator mdxType="ProcessingIndicator" />
	</Item>
	<Item title='errorMessage' subtitle='object' mdxType="Item">
		<ErrorMessage mdxType="ErrorMessage" />
	</Item>
	<Item title='successScreen' subtitle='false | object' mdxType="Item">
		<SuccessScreen mdxType="SuccessScreen" />
	</Item>
    </Group>
    <Group summary='Manual payment handling' mdxType="Group">
	<ManualPaymentHandling mdxType="ManualPaymentHandling" />
    </Group>
    <ClientSessionCachingEnabled mdxType="ClientSessionCachingEnabled" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      